<template>
  <v-container>
    <QuickNavigation :fileData="fileData" :routeHistory="$route" />
    <UploadEmbeddedDocsDropzone :notify="true" />
    <LoanDetailSubMenu />
  </v-container>
</template>

<script>
import QuickNavigation from "@/components/QuickNavigation";
import UploadEmbeddedDocsDropzone from "@/components/UploadEmbeddedDocsDropzone";
import LoanDetailSubMenu from "@/components/LoanDetailSubMenu";

export default {
  name: "UploadSubmissionFiles",
  components: {
    QuickNavigation,
    UploadEmbeddedDocsDropzone,
    LoanDetailSubMenu,
  },
  async mounted() {
    const response = await this.$store
      .dispatch("fileDataApi/getFileDataDetail", {
        loanNumber: this.$route.query.loanNumber,
      })
      .then((resp) => resp)
      .catch((err) => err);

    if (response.status === 200) {
      this.fileData = response.data;
    } else {
      this.$store.commit("statusDialog/showErrorDialog", response.data);
      this.$router.push("/pipeline");
    }
  },
  data() {
    return {
      fileData: null,
    };
  },
  methods: {},
};
</script>
